<template>
    <div>
        <Toolbar>
            <template v-slot:right>
                <div class="btn-group">
                    <ToolbarLink
                        v-if="subscription.can_be_cancelled"
                        class="btn-hover-danger"
                        :href="$route('subscriptions.cancel', subscription.id)">
                        <i class="fas fa-ban text-danger"/>
                        {{ __('actions.end_thing', {thing: __('general.subscription')}) }}
                    </ToolbarLink>
                    <ToolbarLink
                        :href="$route('subscriptions.customers.invoices', {customer: subscription.customer.uid, subscription: subscription.id})">
                        <i class="fas fa-receipt mr-1"/>
                        {{ __('actions.view_thing', {thing: __('subscriptions.invoices')}) }}
                    </ToolbarLink>
                </div>
            </template>
        </Toolbar>

        <Card slim-content>
            <template v-slot:header_custom>
                <Productable class="my-2" :productable="subscription.subscribable"/>
            </template>

            <div class="d-flex flex-column gap-10">
                <div class="d-flex flex-column justify-content-between flex-md-row gap-2 gap-md-20 px-20 text-center">
                    <div class="flex-grow-1">
                        <div class="font-size-h6 text-uppercase">
                            {{ __('general.status') }}
                        </div>
                        <div>
                            <ResponsiveSubscriptionStatus :subscription="subscription"/>
                        </div>
                    </div>
                    <div class="flex-grow-1">
                        <div class="font-size-h6 text-uppercase">
                            {{ __('subscriptions.stores.paid') }}
                        </div>
                        <div>{{ subscription.paid_stores_count }}</div>
                    </div>
                    <div class="flex-grow-1">
                        <div class="font-size-h6 text-uppercase">
                            {{ __('general.date_created') }}
                        </div>
                        <div>{{ $localDateTime(subscription.created_at) }}</div>
                    </div>
                    <!--                    <div class="flex-grow-1">-->
                    <!--                        <div class="font-size-h6 text-uppercase">-->
                    <!--                            {{ __('subscriptions.next_payment') }}-->
                    <!--                        </div>-->
                    <!--                        &lt;!&ndash;                        <div>{{ $localDateTime(subscription.created_at) }}</div>&ndash;&gt;-->
                    <!--                    </div>-->
                </div>

                <div class="border-top border-top-dotted pt-5">
                    <div class="font-weight-bold font-size-lg">
                        {{ __('general.stores') }}
                    </div>
                    <p>
                        {{
                            __('subscriptions.stores.left_with_count', {count: Math.max(0, subscription.paid_stores_count - storesUsed)})
                        }}
                    </p>
                    <div>
                        <Link as="button" class="btn btn-sm btn-light-primary" :href="$route('subscriptions.stores.book')">
                            <i class="fas fa-plus-square"/>
                            {{ __('subscriptions.stores.add') }}
                        </Link>
                    </div>
                </div>

                <div class="border-top border-top-dotted pt-5">
                    <div class="row">
                        <div class="col-md-8">
                            <FeaturesTable :features="subscription.features" plain/>
                        </div>
                        <div class="col-md-4">
                            <div class="font-weight-bold font-size-h3 mb-1">
                                {{ __('subscriptions.incurred_cost') }}
                            </div>
                            <div>
                                <PricingConditionsTable :paid-stores-count="subscription.paid_stores_count"
                                                        :pricing-conditions="subscription.pricing_conditions"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="border-top border-top-dotted pt-5">
                    <div class="table-responsive">
                        <table class="table table-hover table-vertical-center">
                            <thead>
                            <tr>
                                <th>{{ __('subscriptions.addon') }}</th>
                                <th class="text-center">{{ __('general.requested') }}</th>
                                <th class="text-center">{{ __('subscriptions.invoice_status.paid') }}</th>
                                <th class="text-center">{{ __('general.used') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="addon in subscription.addons">
                                <td>{{ getTranslation(addon.lang.name) ?? 'n/a' }}</td>
                                <td class="text-center">{{ addon.pivot.units_requested }}</td>
                                <td class="text-center">{{ addon.pivot.units_paid }}</td>
                                <td class="text-center">{{ addon.pivot.units_used }}</td>
                            </tr>
                            <tr v-if="Object.values(subscription.addons).length === 0">
                                <td colspan="4" class="text-muted">
                                    {{ __('general.things.none_present_yet', {things: __('subscriptions.addon')}) }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!--                        <Link as="button" class="btn btn-sm btn-light-primary mt-1"-->
                        <!--                        :href="$route('subscriptions.addons.book')">-->
                        <!--                            <i class="fas fa-plus-square"/>-->
                        <!--                            {{ __('subscriptions.book_more_addons') }}-->
                        <!--                        </Link>-->
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
import BackButton from "@components/BackButton.vue";
import Card from "@components/Cards/Card.vue";
import Productable from "@components/Subscriptions/Productable.vue";
import FeaturesTable from "@components/Subscriptions/Features/FeaturesTable.vue";
import { Link } from '@inertiajs/vue2';
import Toolbar from "@components/Toolbar.vue";
import ToolbarLink from "@components/ToolbarLink.vue";
import UserLink from "@components/User/UserLink.vue";
import ResponsiveSubscriptionStatus from "@components/Subscriptions/ResponsiveSubscriptionStatus.vue";
import PricingConditionsTable from "@components/Subscriptions/PricingConditionsTable.vue";
import {PermissionsMixin} from "@js/permissions";
import helperMethods from "@mixins/helperMethods";

export default {
    components: {
        PricingConditionsTable,
        ResponsiveSubscriptionStatus,
        UserLink,
        ToolbarLink,
        Toolbar,
        FeaturesTable,
        Productable,
        Card,
        BackButton,
        Link
    },

    mixins: [PermissionsMixin, helperMethods],

    props: {
        subscription: Object,
        storesUsed: Number,
        user: Object
    }
}
</script>
